<template>
  <div class="footer-box flex-column">
    <div class="compang-info">
      <div class="feedback">
        <div class="site-infos">
          <div class="site-name-info">
            <span class="fs24 fw500">元素魔方</span>
            <span class="fs24 fw300">|</span>
            <span class="fs20 fwn">一站式科研服务</span>
          </div>
          <span class="fs36 fw500">{{ system.linknum }}</span>
        </div>
        <div class="contact fs16 fw300">
          <span>工作时间： {{ system.work_time }}</span>
          <span>总部地址： {{ system.address }}</span>
          <span>加入我们： {{ system.linknum }}</span>
        </div>
      </div>
      <div class="about">
        <span class="fs16 fw300">元素魔方全站搜索</span>
        <form :action="`${domain.home}/index/search`" method="get" class="search-bar">
          <input type="text" name="keyword" class="search-input" placeholder="请输入您想搜索的内容">
          <div class="search-btn flex-cc fs16 fw300">搜索</div>
        </form>
        <div class="links-box">
          <div class="links-wrap fs16 fw300">
            <a :href="`${domain.home}/analog`">模拟计算</a>
            <a :href="`${domain.home}/analysis`">数据分析</a>
            <a :href="`${domain.home}/test`">测试表征</a>
            <a :href="`${domain.home}/store`">试剂耗材</a>
            <a :href="`${domain.home}/server`">高性能服务器</a>
            <a :href="`${domain.home}/server`">超算服务</a>
            <a :href="`${domain.home}/patent`">软件专利</a>
            <a :href="`${domain.home}/patent`">科研绘图</a>
            <a :href="`${domain.home}/academic`">学术广场</a>
          </div>
          <div class="offical">
            <div v-for="(item, index) in bottomAd" :key="index" class="offical-item fs12 fw300">
              <img :src="item.src" alt="" class="offical-img">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="friend-list" v-html="company">

    </div>
    <div class="copyright flex-cc fs12 fw300">
      © 2023 元素魔方平台版权所有 沪ICP备2023015691号
    </div>
  </div>
</template>
<script>
import path from "path";
import { getSiteInfo } from "@/api/common";
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  components: {

  },
  props: {

  },
  computed: {
    ...mapGetters(["token", "name", "phone", "avatar"])
  },
  data() {
    return {
      domain: {},
      system: {},
      bottomAd: [],
      company: ''
    };
  },
  created() {
    this.getSiteInfo();
  },
  methods: {
    getSiteInfo() {
      getSiteInfo({}).then(res => {
        this.domain = res.data.domain;
        this.system = res.data.system;
        this.bottomAd = res.data.bottomAd;
        this.company = res.data.company
      });
    },
    logout() {
      this.$store.dispatch("Logout");
      this.$message.success("退出成功");
      this.$router.push("/auth/login");
    }
  }
};
</script>
<style lang="scss" scoped>
.footer-box {
  width: 100%;
  padding-top: 75px;
  background: #222222;
  color: #ffffff;

  .compang-info {
    display: grid;
    grid-template-columns: 470px 670px;
    column-gap: 60px;
    padding-bottom: 30px;

    .feedback {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .contact {
        width: 100%;
        height: 108px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        color: #eaeff0;
      }

      .site-infos {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        margin-bottom: 67px;

        &>.site-name-info {
          display: flex;
          align-items: center;
          column-gap: 17px;
        }
      }
    }

    .about {
      .search-bar {
        width: 100%;
        height: 42px;
        padding-left: 15.5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #3d3d3d;
        margin-top: 29px;

        .search-input {
          width: calc(100% - 145.5px);
          border: none;
          outline: none;
          background-color: transparent;
          color: white;
        }

        .search-btn {
          width: 130px;
          height: 42px;
          background: #ffffff;
          color: #222222;
          cursor: pointer;
        }
      }

      .links-box {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-top: 20px;

        .links-wrap {
          display: grid;
          grid-template-columns: repeat(3, auto);
          column-gap: 45px;
          row-gap: 30px;

          &>span {
            cursor: pointer;
          }
        }

        .offical {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          column-gap: 20px;

          .offical-item {
            line-height: 12px;
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            align-items: center;

            .offical-img {
              width: 140px;
              height: 140px;
            }
          }
        }
      }
    }
  }

  .friend-list {
    width: 1200px;
    background-color: #3d3d3d;
    padding: 15px 0;
    margin-bottom: 30px;
  }

  .copyright {
    width: 100%;
    padding: 39px 0;
    border-top: solid 1px #ccd7db;
    line-height: 12px;
    color: #ffffff;
  }
}
</style>